import { Inject, Injectable, Injector } from '@angular/core';


import { IntraOne_hytek_pick_to_light_api_1310Service } from './IntraOne.flow.index';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public IntraOne: IntraOne_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _hytek_pick_to_light_api_1310: IntraOne_hytek_pick_to_light_api_1310Service;
  public async hytek_pick_to_light_api_1310(inParams: { shippingContainerId: number }): Promise< { result?: any }> {
    if(!this._hytek_pick_to_light_api_1310) {
      this._hytek_pick_to_light_api_1310 = this.injector.get(IntraOne_hytek_pick_to_light_api_1310Service);
    }
    return this._hytek_pick_to_light_api_1310.run(inParams);
  }
   
   

   
}
